/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromValidate from 'Data/validate.js'
import CancelAction from './CancelAction/index'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import React from 'react'
import TysiaTextarea from 'DesignSystem/TysiaTextarea/index'
import TysiaTextareaContent from 'DesignSystem/TysiaTextarea/TysiaTextareaContent/index'
import TysiaTextareaField from 'DesignSystem/TysiaTextarea/TysiaTextareaField/index'
import Users from './Users/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Expanded/Content/Notes/Add/Content",
  onChange,
  isInvalid
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let editedNoteNoteValueData = fromData.useDataValue({ viewPath,
context: 'edited_note',
path: 'note',
})
let editedNoteNoteIsValidData = fromData.useDataIsValid({ viewPath,
context: 'edited_note',
path: 'note',
validate: fromValidate.text,
required: true,
})
let editedNoteNoteChangeData = fromData.useDataChange({ viewPath,
context: 'edited_note',
path: 'note',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
 marginTop={dtSpaceXs}
/>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Users
  viewPath={`${viewPath}/Users`}
/>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
/>
</div>
<TysiaTextarea
  viewPath={`${viewPath}/TysiaTextarea`}
 marginTop={dtSpaceS}
 autoFocus={true}
 height="auto"
 data="edited_note.note"
 value={editedNoteNoteValueData}
 onChange={editedNoteNoteChangeData}
 validate="/Data/validate.js text"
 invalid={!editedNoteNoteIsValidData}
 required={true}
 size="small"
>
{childProps => (
<TysiaTextareaContent
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaContent`}
>
{childProps => (
<TysiaTextareaField
{...childProps}
  viewPath={`${viewPath}/TysiaTextareaField`}
 placeholder="Waiting for your input..."
/>
)}
</TysiaTextareaContent>
)}
</TysiaTextarea>
{children}
</React.Fragment>)
}